import React from "react";
import { ListItem, Box, TextField, IconButton, Skeleton } from "@mui/material";
import { DragIndicator as DragIcon } from "@mui/icons-material";
import { RemoveIcon, RemoveIconRed } from "@/assets/images";

interface NewTabRowProps {
  value: string;
  error: string | null;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  isHovered: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  inputRef: React.RefObject<HTMLInputElement | null>;
}

export const NewTabRow: React.FC<NewTabRowProps> = ({
  value,
  error,
  onChange,
  onSave,
  onCancel,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  inputRef,
}) => (
  <ListItem disableGutters disablePadding sx={{ mb: "10px" }}>
    <Box sx={{ display: "flex", alignItems: "center", width: "100%", padding: "0 16px" }}>
      <DragIcon sx={{ mr: 2, color: "text.secondary" }} />
      <Box sx={{ flexGrow: 1 }}>
        <TextField
          size="small"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") onSave();
          }}
          onBlur={onSave}
          inputProps={{ maxLength: 40 }}
          fullWidth
          error={!!error}
          helperText={error}
          InputProps={{ sx: { borderRadius: "8px" } }}
          inputRef={inputRef}
        />
      </Box>

      <IconButton
        aria-label="cancel"
        onClick={onCancel}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        sx={{ ml: 1, color: "text.secondary", "&:hover": { color: "#D80000" } }}
      >
        {isHovered ? <RemoveIconRed /> : <RemoveIcon />}
      </IconButton>
    </Box>
  </ListItem>
);

export const NewTabRowSkeleton: React.FC = () => (
  <ListItem disableGutters disablePadding sx={{ mb: "10px", opacity: 0.6 }}>
    <Box sx={{ display: "flex", alignItems: "center", width: "100%", padding: "0 16px" }}>
      <DragIcon sx={{ mr: 2, color: "text.disabled" }} />
      <Skeleton variant="rounded" height={40} sx={{ flexGrow: 1, borderRadius: "8px" }} />
      <Skeleton variant="circular" width={40} height={40} sx={{ ml: 1 }} />
    </Box>
  </ListItem>
);
